import Component from '@glimmer/component';
import type { AgreementsStatus } from 'garaje/models/agreeable';

const ICON_MAPPING = {
  not_applicable: '/assets/images/gray-dash-small.svg',
  not_signed: '/assets/images/cross-small-red.svg',
  pending: '/assets/images/gray-dash-small.svg',
  signed: '/assets/images/checkmark-small-gray.svg',
  skipped: '/assets/images/gray-dash-small.svg',
};

const LEGAL_DOCUMENTS_STATUS_MAPPING = {
  not_applicable: 'N/A',
  not_signed: 'Not signed',
  pending: 'Pending',
  signed: 'Signed',
  skipped: 'Skipped',
};

interface LegalDocumentsStatusSignature {
  Args: {
    status: AgreementsStatus;
  };
  Element: HTMLSpanElement;
}

export default class LegalDocumentsStatus extends Component<LegalDocumentsStatusSignature> {
  get displayStatus(): string {
    return LEGAL_DOCUMENTS_STATUS_MAPPING[this.args.status];
  }

  get icon(): string {
    return ICON_MAPPING[this.args.status];
  }

  <template>
    {{#if this.displayStatus}}
      <span class="whitespace-nowrap" data-test-nda-column-status ...attributes>
        <img src={{this.icon}} alt="" role="presentation" />
        {{this.displayStatus}}
      </span>
    {{/if}}
  </template>
}
